import cx from 'classnames';
import PropTypes from 'prop-types';

import { FilterResourceByTag } from 'src/components/FilterResourceByTag';
import { FilterResourceByType } from 'src/components/FilterResourceByType';

import { FILTER_TYPE, MESSAGING_BANK_ASSET } from '../../lib';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  filters: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  shouldIncludeAudioVideoResources: PropTypes.bool,
};

const defaultProps = {
  className: null,
  tags: [],
  shouldIncludeAudioVideoResources: false,
};

export const Filters = ({
  className,
  tags,
  filters,
  onChange,
  shouldIncludeAudioVideoResources,
}) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <FilterResourceByType
        value={filters[FILTER_TYPE.types]}
        onChange={(newValue) => onChange(FILTER_TYPE.types, newValue)}
        typeToAdd={MESSAGING_BANK_ASSET}
        shouldIncludeAudioVideoResources={shouldIncludeAudioVideoResources}
      />
      <FilterResourceByTag
        value={filters[FILTER_TYPE.tags]}
        onChange={(newValue) => onChange(FILTER_TYPE.tags, newValue)}
        tags={tags}
      />
    </div>
  );
};

Filters.displayName = 'Filters';
Filters.propTypes = propTypes;
Filters.defaultProps = defaultProps;
